import { Box, Button, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import SuccessIcon from "src/assets/svg-icons/success.svg";
import { ICarRequest } from "src/types/car-request";
import { TicketInfoBox } from "../ticket-info-box";

const RequestedSuccessfully = ({
  data,
  setCurrentStep,
  hasDescription = true,
}: {
  data: ICarRequest;
  setCurrentStep: Function;
  hasDescription?: boolean;
}) => {
  const { t } = useTranslation();

  const {
    enableFreeLocation,
    isOnlinePaymentsEnabled,
    combinedPaidAmount,
    combinedUnpaidAmount,
    combinedPrice
  } = data || {};

  const isFreeTicket = enableFreeLocation || combinedPrice === 0;

  const handlePayNow = () => {
    setCurrentStep(2); // go to payment step
  };

  const paymentStatus =
    !isFreeTicket && combinedUnpaidAmount <= 0
      ? "Paid"
      : !isFreeTicket && combinedPaidAmount > 0 && combinedUnpaidAmount > 0
        ? "Partially Paid"
        : "Unpaid";

  return (
    <Box>
      <Stack alignItems={"center"} mb={2}>
        <img width={130} src={SuccessIcon} alt="" />
        <Typography mt={1} mb={1.2} fontSize={"24px"} fontWeight={600}>
          {t("requestedSuccessfully")}
        </Typography>
        {!isFreeTicket && hasDescription ? (
          <Typography align="center">{t("after30MinutesExtraFees")}</Typography>
        ) : null}
      </Stack>
      <TicketInfoBox data={data} />
      {paymentStatus !== "Paid" && !isFreeTicket && isOnlinePaymentsEnabled && (
        <Button
          fullWidth
          variant="contained"
          sx={{ mt: "30px" }}
          onClick={handlePayNow}
        >
          {t("payNow")}
        </Button>
      )}
    </Box>
  );
};

export default RequestedSuccessfully;
